module.exports = __webpack_public_path__ + "static/media/download_file.2a8de1ff.svg";